export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#ffffff",
    hexDark: "#0b1826",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "#f9fafb",
    hexDark: "#11273c",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "#ebeef1",
    hexDark: "#23364d",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "#11273c",
    hexDark: "#d5dde6",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "#11273c",
    hexDark: "#f4f7fa",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "#667185",
    hexDark: "#8fa0b6",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "#49a78f",
    hexDark: "#57b39c",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "#eaf6f3",
    hexDark: "#12302a",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "#178166",
    hexDark: "#7ac7b3",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "#c07d3a",
    hexDark: "#c07d3a",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "#f6ebdd",
    hexDark: "#2e2317",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "#a5642a",
    hexDark: "#d99a5b",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "#c0483d",
    hexDark: "#c0483d",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "#f7e6e3",
    hexDark: "#2e1715",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "#a83c31",
    hexDark: "#d97b70",
  },
];

export const FONTS = {
  display: "Figtree",
  body: "Figtree",
  mono: "IBM Plex Mono",
};
